import { cn } from '@/lib/cn';
import { DataStreamBaseTileConfig } from '@squaredup/data-streams';
import NoDataPlaceholder from 'components/NoDataPlaceholder';
import { useMemo, useState } from 'react';
import { useDatasetContext } from 'ui/editor/dataStream/contexts/DatasetContext';
import { useTileEditorContext } from 'ui/editor/dataStream/contexts/TileEditorContext';
import { DataTable } from 'ui/editor/dataStream/TileEditor/preview/DataTable';
import { UnshapedDataOption } from 'ui/editor/dataStream/TileEditor/preview/UnshapedDataOption';
import { UnshapedDataTable } from 'ui/editor/dataStream/TileEditor/preview/UnshapedDataTable';
import { Tabs } from 'ui/Tabs';
import { TileWarnings } from 'ui/tile/TileWarnings';

const defaultProps = {
    notConfiguredError: <NoDataPlaceholder message='No data' />
};

export const PluginImportConfigEditorDataPanel = () => {
    const { tileConfig } = useTileEditorContext();
    const { datasets } = useDatasetContext();

    const [isShowingUnshapedData, setIsShowingUnshapedData] = useState(false);

    const dataTabs = useMemo(() => {
        return [
            {
                label: 'Data',
                component: (
                    <div className='h-full p-4'>
                        {isShowingUnshapedData ? (
                            <UnshapedDataTable {...defaultProps} />
                        ) : (
                            <DataTable {...defaultProps} />
                        )}
                    </div>
                )
            }
        ];
    }, [isShowingUnshapedData]);

    const datasetConfig = datasets[0]?.config as DataStreamBaseTileConfig;

    return (
        <div
            className={cn(
                'relative z-0 h-full min-w-0 min-h-0 border bg-tileBackground border-dividerTertiary isolate'
            )}
        >
            <Tabs
                tabs={dataTabs}
                tabsID='datastreamDataTabs'
                tabListClassName='w-auto'
                additionalControl={
                    <div className='flex px-4 my-auto ml-auto space-x-3'>
                        <UnshapedDataOption
                            isShowingUnshapedData={isShowingUnshapedData}
                            setIsShowingUnshapedData={setIsShowingUnshapedData}
                        />
                        {/* Show errors for all data sets if no specific data set is selected */}
                        <TileWarnings config={datasetConfig ?? tileConfig} />
                    </div>
                }
            />
        </div>
    );
};
